export default {
    searchText: 'Search by Bureau / Organization',
    search: 'Search',
    orgId: 'Org ID',
    bureau: 'Bureau',
    bureauAcronym: 'Bureau Acronym',
    parentId: 'Parent ID',
    organization: 'Organization',
    totalEmployee: 'Total Employee'
}
